// frontend/src/components/dfs/skeletons/CurrentLineupSkeleton.tsx
import React from 'react';

const SkeletonPlayerRow: React.FC = () => (
    <div className="flex items-center p-2.5 sm:p-3 rounded bg-primary/70 shadow-sm min-h-[60px] sm:min-h-[72px]">
        {/* Left side: Slot Position & Info Block */}
        <div className="flex-grow flex items-center space-x-2 sm:space-x-3 overflow-hidden mr-2">
            <div className="h-5 w-7 bg-gray-700 rounded flex-shrink-0"></div> {/* Slot Position */}
            <div className="flex flex-col min-w-0 flex-grow space-y-1.5">
                <div className="h-4 bg-gray-700 rounded w-3/4"></div> {/* Player Name */}
                <div className="h-3 bg-gray-700 rounded w-1/2"></div> {/* Stats Line */}
                <div className="h-3 bg-gray-700 rounded w-5/6"></div> {/* Matchup Line */}
            </div>
        </div>
        {/* Right side: Salary & Button Placeholder */}
        <div className="flex-shrink-0 flex flex-col items-end space-y-1 sm:space-y-1.5 ml-1">
            <div className="h-4 bg-gray-700 rounded w-12"></div> {/* Salary */}
            <div className="h-5 w-5 sm:h-6 sm:w-6 bg-gray-700 rounded-full"></div> {/* Button */}
        </div>
    </div>
);

const CurrentLineupSkeleton: React.FC = () => {
  return (
    <div className="bg-surface-card p-3 sm:p-4 rounded-lg shadow-lg animate-pulse border-2 border-gray-700/50">
      {/* Header Skeleton */}
      <div className="flex justify-center items-baseline mb-4 border-b border-gray-700/50 pb-3 text-center">
        <div className="h-5 sm:h-6 bg-gray-700 rounded w-1/2"></div> {/* Budget Remaining Text + Value */}
      </div>

      {/* Slots Skeleton — flat list of 8 player rows (2 per FW/MF/DF/FLEX) */}
      <div className="space-y-1.5 sm:space-y-2">
        {Array.from({ length: 8 }).map((_, i) => (
          <SkeletonPlayerRow key={i} />
        ))}
      </div>
    </div>
  );
};

export default CurrentLineupSkeleton;